<i18n>
{
  "en": {
    "linkTree": "LinkTree",
    "add": "Add",
    "deleteTitle": "Do you want to delete link tree: \"{0}\" ?",
    "deleteDescription": "This can not be undone",
    "delete": "Delete",
    "createLinkTreeSuccess": "Created link tree \"{0}\" !",
    "createLinkTreeError": "Error creating link tree. Please, try again later.",
    "editLinkTreeSuccess": "Link tree \"{0}\" was successfully edited!",
    "editLinkTreeError": "Error editing link tree \"{0}\". Please, try again later.",
    "deleteLinkTreeSuccess": "Link tree \"{0}\" was deleted"
  },
  "es": {
    "linkTree": "Arbol de links",
    "add": "Añadir",
    "deleteTitle": "¿Desea borrar el arbol de links: \"{0}\" ?",
    "deleteDescription": "Este cambio es irreversible",
    "delete": "Eliminar",
    "createLinkTreeSuccess": "Creado el arbol de links \"{0}\" !",
    "createLinkTreeError": "Error creando el arbol de links. Inténtelo de nuevo más tarde.",
    "editLinkTreeSuccess": "El arbol de links \"{0}\" se editó correctamente",
    "editLinkTreeError": "Error editando el arbol de links \"{0}\". Inténtelo de nuevo más tarde.",
    "deleteLinkTreeSuccess": "El arbol de links \"{0}\" fue borrado"
  }
}
</i18n>
<template>
  <div>
    <div class="d-flex flex-wrap mx-7 mt-3 mb-3">
      <v-row>
          <v-col cols="12" align-self="center" class="pa-0 my-4">
            <div class="text-center text-h5">
              {{ $t('linkTree') }}
            </div>
          </v-col>
          <v-col align-self="end" class="pa-0 te">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon class="plus-icon mr-0" v-on="on" v-bind="attrs"
                       @click="openModal">
                  <v-icon color="grey" large>mdi-plus</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('add') }}</span>
            </v-tooltip>
          </v-col>
      </v-row>
    </div>
    <v-list>
      <div>
        <link-tree-row
          v-for="linkTree in linkTreeList"
          :key="linkTree.guid"
          :linkTree="linkTree"
          @edit="() => onEdit(linkTree)"
          @delete="() => onDelete(linkTree)"
        >
        </link-tree-row>
      </div>
    </v-list>
    <link-tree-create-edit-modal
      :visible="createModal"
      @confirm="onConfirmCreate"
      @cancel="onCloseModal"
      :linkTree="linkTreeToCreate"
      type="create"
    />
    <link-tree-create-edit-modal
      :visible="editModal"
      @confirm="onConfirmEdit"
      @cancel="onCloseModal"
      :linkTree="linkTree"
      type="edit"
    />
    <dynameat-confirmation-modal :visible="deleteModal"
                                 :title="$t('deleteTitle', [userRoleToDeleteTitle])"
                                 :description="$t('deleteDescription')"
                                 :confirm-text="$t('delete')" @confirm="onDeleteLinkTree"
                                 @cancel="onCloseModal"/>
  </div>
</template>
<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import { Components, MapActions, MapGetters } from '@core/helpers/decorators';
import { Watch } from 'vue-property-decorator';
import { createErrorNotification, createSuccessNotification } from '@ulibs/unnotificationsqueue';
import DynameatConfirmationModal from '@dynameat/components/DynameatConfirmationModal';
import { normalizeStr } from '@core/helpers';
import { LinkTree } from '../models';
import LinkTreeRow from '../components/linkTreeRow.vue';
import LinkTreeCreateEditModal from '../components/linkTreeCreateEditModal.vue';

@Component()
@Components({
  LinkTreeRow,
  DynameatConfirmationModal,
  LinkTreeCreateEditModal
})
@MapActions(['linkTreeListRequest', 'menuListRequest', 'deleteLinkTree', 'createLinkTree', 'editLinkTree', 'addNotification'])
@MapGetters(['linkTreeList'])
export default class LinkTreeList extends Vue {
  createModal = false;

  editModal = false;

  deleteModal = false;

  linkTreeToCreate = null;

  linkTree = null;

  linkTreeToDelete = null;

  async created() {
    await this.loadData();
  }

  async loadData() {
    await this.linkTreeListRequest(this.$route.params.pointOfSaleGuid);
    await this.menuListRequest(this.$route.params.pointOfSaleGuid);
  }


  openModal() {
    this.linkTreeToCreate = LinkTree.toInstance();
    this.createModal = true;
  }

  onEdit(linkTree) {
    this.linkTree = LinkTree.toInstance(linkTree.serialize());
    this.editModal = true;
  }

  onDelete(linkTree) {
    this.linkTreeToDelete = LinkTree.toInstance(linkTree.serialize());
    this.deleteModal = true;
  }

  onCloseModal() {
    this.createModal = false;
    this.editModal = false;
    this.deleteModal = false;
  }

  async onConfirmCreate(linkTree) {
    console.log('linkTree', linkTree);
    try {
      await this.createLinkTree(linkTree);
      this.addNotification(createSuccessNotification(this.$t('createLinkTreeSuccess', [linkTree.name]), null, 3000));
    } catch (e) {
      this.addNotification(createErrorNotification(this.$t('createLinkTreeError', [linkTree.name])));
    } finally {
      this.onCloseModal();
      this.linkTreeToCreate = null;
    }
  }

  async onConfirmEdit(linkTree) {
    try {
      await this.editLinkTree(linkTree);
      this.addNotification(createSuccessNotification(this.$t('editLinkTreeSuccess', [linkTree.name]), null, 3000));
    } catch (e) {
      this.addNotification(createErrorNotification(this.$t('createLinkTreeError', [linkTree.name])));
    } finally {
      this.onCloseModal();
      this.linkTree = null;
    }
  }

  async onDeleteLinkTree() {
    try {
      await this.deleteLinkTree(this.linkTreeToDelete);
      this.addNotification(createSuccessNotification(this.$t('editLinkTreeSuccess', [this.linkTreeToDelete.name]), null, 3000));
    } catch (e) {
      this.addNotification(createErrorNotification(this.$t('createLinkTreeError', [this.linkTreeToDelete.name])));
    } finally {
      this.onCloseModal();
      this.linkTreeToDelete = null;
    }
  }
  @Watch('$route')
  async onRouteChange(to, from) {
    if (to.params.pointOfSaleGuid !== from.params.pointOfSaleGuid) {
      await this.loadData();
    }
  }
}
</script>
